import React, { useState } from "react"
import styles from "./OrderModal.module.scss"
import OrderModalBlock from "./OrderModalBlock"
import clsx from "clsx"
import { useTranslation } from "react-i18next"
import { checkAllowCamera } from "../../../utils/helpers"
import { setIsAllowCameraModal } from "../../../redux/slice/modals"
import { useDispatch } from "react-redux"
import QrScanModal from "../QrScanModal/QrScanModal"
import IconBtn from "../../Assets/IconBtn/IconBtn"
import { QRMobIcon } from "../../../icons/QRMobIcon"
import { useFormikContext } from "formik"
import * as Sentry from "@sentry/react"
import { useLocation, useNavigate } from "react-router-dom"
import AnotherObjModal from "../AnotherObjModal/AnotherObjModal"
import { useDeleteDraftOrderMutation, useSetDraftOrderMutation } from "../../../redux/api/content"
import { deepDiff } from "../../../utils/deepDiff"
import { isArray } from "lodash"

interface Props {
  el: any
  isRequired?: boolean
  isFirstQrDate?: string | null
  error?: boolean
}

const OrderModalQRBlock: React.FC<Props> = ({ el, isRequired, isFirstQrDate, error }) => {
  const { values, setFieldValue, errors, setFieldTouched, touched, setFieldError } = useFormikContext<{
    [key: string]: any
  }>()
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [setDraftOrder] = useSetDraftOrderMutation()
  const [deleteDraftOrder] = useDeleteDraftOrderMutation()

  const [isQrScanModal, setQrScanModal] = useState<boolean>(false)
  const [isAnotherObjectModal, setAnotherObjectModal] = useState<boolean>(false)
  const [anotherID, setAnotherID] = useState<string | null>(null)

  const checkAllowCameraFn = async () => {
    checkAllowCamera()
      .then(() => {
        setQrScanModal(true)
      })
      .catch(() => {
        dispatch(setIsAllowCameraModal(true))
      })
  }

  const checkAnotherObject = (objectID?: string) => {
    const currentObjectID = values?.technical_object_id
    if (currentObjectID && objectID && currentObjectID !== objectID) {
      setAnotherID(objectID)
      setTimeout(() => {
        setAnotherObjectModal(true)
      }, 300)
    }
  }

  const handlerAnotherObj = async () => {
    if (!anotherID) {
      setAnotherObjectModal(false)
      return
    }

    const val = { ...values }
    val.technical_object_id = anotherID
    delete val?.technical_object_id
    delete val?.service_id
    delete val?.count
    const diffValue = deepDiff([], val)?.filter((v) => {
      if (v?.data && isArray(v.data) && !v.data.length) return false
      if (v?.data === "" || v?.data === null || v?.data === undefined) return false
      return true
    })

    await setDraftOrder({
      id: values.service_id,
      data: {
        options: diffValue,
        technical_object_id: anotherID,
      },
    })

    const urlSplit = location.pathname.split("/")
    urlSplit.forEach((u, index) => {
      if (u === "object" && index !== urlSplit.length - 1) {
        urlSplit[index + 1] = anotherID
      }
    })
    navigate(urlSplit.join("/"))
    // удаляем из localStorage и запросом сам черновик
    const currentObjectID = values?.technical_object_id
    const serviceID = values?.service_id
    // const localSavedValues = localStorage.getItem("savedOrder")
    if (currentObjectID && serviceID) {
      // if (localSavedValues) {
      //   localStorage.setItem(
      //     "savedOrder",
      //     JSON.stringify(
      //       JSON.parse(localSavedValues).filter(
      //         (el: any) => !(el?.service_id === serviceID && el.technical_object_id === currentObjectID),
      //       ),
      //     ),
      //   )
      // }
      deleteDraftOrder({ technical_object_id: currentObjectID, id: serviceID })
        .unwrap()
        .catch((err: Error) => {
          console.error("error in deleteDraftOrder: ", err)
        })
    }
    setAnotherID(null)
    setAnotherObjectModal(false)
  }

  return (
    <>
      <OrderModalBlock title={`${el?.name}`} isRequired={isRequired} className={styles.qrWrapBlock} error={error}>
        <>
          {(!values[el.id] && !!isFirstQrDate) || values[el.id] ? (
            <div className={styles.QRInput}>
              <input disabled value={isFirstQrDate || values[el.id] || undefined} className={`input`} />
              {/* Для удаления времени вов ремя отладки */}
              {/* <div
            onClick={() => {
              void setFieldValue(`${el.id}`, "")
            }}
          >
            DELETE
          </div> */}
              <IconBtn
                icon={<QRMobIcon />}
                className={styles.QRInput__icon}
                onClick={() => {
                  checkAllowCameraFn()
                }}
              />
            </div>
          ) : (
            <>
              <div
                onClick={() => {
                  checkAllowCameraFn()
                }}
                className={`${styles.qrBlock} ${!!errors?.[el?.id] && !!touched?.[el?.id] ? "error" : ""}`}
              >
                <QRMobIcon />
                {t("qr.scanQr")}
              </div>
            </>
          )}
          {touched?.[el?.id] && errors && errors?.[el.id] && errors[el.id]?.toString() !== "empty" ? (
            <span className={clsx("error-text", styles.qrWrapBlock__error)}>{errors[el.id]?.toString()}</span>
          ) : null}
        </>

        {isQrScanModal && (
          <QrScanModal
            open={isQrScanModal}
            setOpen={setQrScanModal}
            afterScanningFunc={(time?: string, objectID?: string) => {
              if (time) void setFieldValue(`${el.id}`, time)
              setQrScanModal(false)
              checkAnotherObject(objectID)
            }}
            callbackError={(err: any) => {
              void setFieldTouched(`${el.id}`)
              const errorTxt = JSON.stringify(err)
              if (errorTxt !== "{}" && errorTxt !== "" && errorTxt !== "undefined" && errorTxt !== undefined) {
                Sentry.captureException(Error(`Ошибка во время сканирования QR-кода, Error - ${errorTxt}`))
              }
              setTimeout(() => {
                setFieldError(`${el.id}`, err || t("qr.scanningErrorQr"))
              }, 0)
              setQrScanModal(false)
            }}
          />
        )}
        {isAnotherObjectModal && (
          <AnotherObjModal
            open={isAnotherObjectModal}
            setOpen={setAnotherObjectModal}
            callbackSubmit={handlerAnotherObj}
          />
        )}
      </OrderModalBlock>
    </>
  )
}

export default OrderModalQRBlock
